export { default as BagAddOutlineIcon } from './BagAddOutlineIcon';
